import React from 'react'

const Benefits = () => {
  return (
    <div>
      <p>Benefits</p>
    </div>
  )
}

export default Benefits
